import React from "react";
import projectsData from "../../data/projectsData";

const HeaderSocials = () => {
  const socialLinks = projectsData.socialLinks;
  return (
    <div className="home_socials">
      {socialLinks.map((social) => (
        <a
          key={social.id}
          href={social.url}
          className="home_social-link"
          target="_blank"
          rel="noopener noreferrer"
          title={social.name}
        >
          <i className={social.icon} aria-hidden="true"></i>
        </a>
      ))}
    </div>
  );
};

export default HeaderSocials;
